
export const formatD1RetentionData = ( list = [] ) => {
	return list.d1Percent.map ( item => ( { date: item.date, count: parseInt ( item.d1Percentage ) === -1 ? "NA" : `${ item.d1Percentage }%` } ) );
};